import { ITipoPesoAtendimento } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoPesoAtendimento/TipoPesoAtendimentoInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export function ListarTipoPesoAtendimentoService(ID_TIPO_CASO: number) {
    return Service(
        Axios.get<Array<ITipoPesoAtendimento>>(
            `/home/tipopesoatendimento/listartipopesoatendimento?ID_TIPO_CASO=${ID_TIPO_CASO}`
        )
    );
}
export function GetTipoPesoAtendimentoService(
    ID_TIPO_PESO_ATENDIMENTO: number
) {
    return Service(
        Axios.get<ITipoPesoAtendimento>(
            `/home/tipopesoatendimento/gettipopesoatendimento?ID_TIPO_PESO_ATENDIMENTO=${ID_TIPO_PESO_ATENDIMENTO}`
        )
    );
}
export function CadastrarTipoPesoAtendimentoService(
    tipoPesoAtendimento: ITipoPesoAtendimento
) {
    return Service(
        Axios.post(
            `/home/tipopesoatendimento/cadastrartipopesoatendimento`,
            tipoPesoAtendimento
        )
    );
}
export function AtualizarTipoPesoAtendimentoService(
    tipoPesoAtendimento: ITipoPesoAtendimento
) {
    return Service(
        Axios.put(
            `/home/tipopesoatendimento/atualizartipopesoatendimento`,
            tipoPesoAtendimento
        )
    );
}
export function DeletarTipoPesoAtendimentoService(
    ID_TIPO_PESO_ATENDIMENTO: number
) {
    return Service(
        Axios.delete(
            `/home/tipopesoatendimento/deletartipopesoatendimento?ID_TIPO_PESO_ATENDIMENTO=${ID_TIPO_PESO_ATENDIMENTO}`
        )
    );
}
